module.exports = __webpack_public_path__ + "media/images/help/emp_submission_sdl-14ebc0d8f5f29c444313235fd12745bb.png";